import { useQuery } from '@tanstack/react-query';
import { UserDailiesAuditRequest } from 'src/api/FiretrolApiClient';
import { dailyApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Per-user daily submission counts for a week, for the submission report. */
export function useDailySubmissionReport(
  request: UserDailiesAuditRequest | null,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: queryKeys.dailys.submissionReport(request ?? {}),
    queryFn: ({ signal }) =>
      dailyApiClient.listUserAudit(request!, toCancelToken(signal)),
    enabled: !!request && options?.enabled !== false,
    staleTime: 0,
    meta: { errorContext: 'daily submission report' },
  });
}
